export default "https://ikedayama-front-0.s3-ap-northeast-1.amazonaws.com/20260113030454/logo-bundle-63192261fe8f0b665521fe826d8ebef5.svg";